module.exports = __webpack_public_path__ + "img/is.804c997b.svg";